export default __webpack_public_path__ + "static/yeah-bunny-8d008a29a4ff716097b6d1e2f39fa7f8.png";